<mat-form-field appearance="outline" class="w-100 sort-by">
	<mat-icon matPrefix svgIcon="sort_by"></mat-icon>

	<mat-select [(ngModel)]="selectedSortBy" class="custom-select" hideMatArrow>
		<mat-select-trigger>
			{{ getSelectedLabel(selectedSortBy) | translateWithKeys }}
	   </mat-select-trigger>
		@for (option of sortByOptions; track $index) {
			<mat-option [value]="option?.value" (click)="selectionChange(option.value)">{{option?.label | translate}}</mat-option>
		}
	</mat-select>

	<mat-icon matSuffix svgIcon="arrow_down" class="custom-arrow"></mat-icon>
</mat-form-field>
